export default "/fonts/RV-Harmonia-Bold.svg?1c4e75e2f7368b4c52618b249ba8c8cf";